<template>
  <div class="container text-center py-3">
    <h2>O nama</h2>
    <div class="row pt-3">
      <div class="col-sm-4">
        <h5>Priznanja</h5>
        <img
          src="../assets/img/igprog-awards.png"
          class="img-fluid"
          alt="igprog-priznanja"
          title="Priznanja"
        />
      </div>
      <div class="col-sm-8 text-justify">
        <c-about-us />
      </div>
    </div>
  </div>
</template>

<script>
import cAboutUs from "../components/cAboutUs.vue";
export default {
  metaInfo: {
    titleTemplate: "%s | O nama",
    meta: [
      {
        name: "description",
        content:
          "IG PROG, OBRT ZA RAČUNALNO PROGRAMIRANJE posluje od 2012 godine sa sjedištem u Rijeci.",
      },
    ],
  },
  components: {
    cAboutUs,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/aboutus.vue